import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { RelatorioRecadastramentoService } from 'app/service/relatorio-recadastramento/relatorio.service';
import * as Chart from 'chart.js';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { DadosExcecoesService } from 'app/service/dados-excecoes/dados-excecoes.service';
import { AnosCampanha } from 'app/model/anosCampanha.dto';
import { PeriodoData } from 'app/model/periodoData.dto';
import { STATUS_DO_REGISTRO } from './relatorio-analitico-recadastramento.constants';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RelatorioAnalitico } from 'app/model/relatorioAnalitico.dto';
import { RelatorioParams } from 'app/model/relatorioParams.dto';
import { ServidorService } from "../../service/servidor/servidor.service";

@Component({
  selector: 'app-relatorio-analitico-recadastramento',
  templateUrl: './relatorio-analitico-recadastramento.component.html',
  styleUrls: ['./relatorio-analitico-recadastramento.component.sass']
})
export class RelatorioAnaliticoRecadastramentoComponent implements OnInit {
  @ViewChild('sinteticoChart', { static: true }) chartCanvas: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['matricula', 'nome', 'lotacacao', 'dataInicio', 'dataFinalizacao', 'status']
  dataSourceModal: any[];
  shouldShowTable: boolean = false;
  totalElements: number = 0;
  anoPesquisa: number = 0;
  tipoCampanhaPesquisa: number = 0;
  pageSize: number = 5;
  numberPages: number;
  mostraResultado: boolean = false;

  resultadoRelatorioAnalitico: any[]

  form: FormGroup;
  chart: Chart;
  chartPizza: Chart;

  anos: number[];
  matricula: number;
  statusDoRegistro = STATUS_DO_REGISTRO;

  servidorDigitado: string;
  options: any[] = [];
  filteredOptions: any[] = [];

  existeGrafico: boolean = false;
  relatorioAnalitico: any;
  showDownloadButton: boolean = true;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private relatorioService: RelatorioRecadastramentoService,
    private dadosExcecoesService: DadosExcecoesService,
    private toasterService: ToastrService,
    private servidorService: ServidorService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      ano: ['', [Validators.required, Validators.pattern('^[2][0-9][0-9][0-9]+$')]],
      dataInicio: ['', Validators.required],
      dataFim: ['', Validators.required],
      matricula: [''],
      statusRegistro: ['', [Validators.required]]
    });

    this.form.get('matricula').valueChanges
      .pipe(
        debounceTime(400)
      )
      .subscribe((value) => {
        if (value && value.length >= 4) {
          this.buscarServidor();
        }
      })

    this.anosCampanha();
  }
  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.clear();

      this.chart.destroy();
    }
  }
  checkDiffData() {
    if (this.form.value.dataFim < this.form.value.dataInicio && this.form.value.dataFim != '' && this.form.value.dataFim != null) {
      this.existeGrafico = false;
      this.toastrService.warning("Data de inicio maior que data fim.")
      this.form.controls.dataFim.reset()
    }
  }

  periodoCampanha() {
    if (this.form.controls.ano.status == 'VALID') {
      this.relatorioService.periodoCampanho(this.form.value.ano).subscribe((periodoCampanha: any) => {
        this.form.patchValue({
          dataInicio: periodoCampanha.dataInicio,
          dataFim: periodoCampanha.dataFim
        });
      },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  anosCampanha() {
    this.getAnosCampanha()
      .subscribe(
        (response: AnosCampanha[]) => {
          this.anos = response
            .map(item => item.anos)
            .filter((value, index, self) => self.indexOf(value) === index);
          //this.anos = response.map(item => item.anos);
        },
        (error) => {
          console.error(error);
        }
      )
  }

  onAnoChange(event: MatSelectChange) {
    const selectedAno = event.value as number;

    this.getPeriodo(selectedAno)
      .subscribe(
        (response: PeriodoData) => {
          this.preencherCamposData(response)
        },
        (error) => {
          console.error(error);
        }
      )
  }

  private getAnosCampanha() {
    return this.relatorioService.anosCampanha();
  }

  private getPeriodo(ano) {
    return this.relatorioService.periodoCampanho(ano);
  }

  private preencherCamposData(data: PeriodoData) {
    if (data?.dataInicio && data?.dataFim) {
      const dataInicio = moment(data.dataInicio).toDate();
      const dataFim = moment(data.dataFim).toDate();

      this.form.patchValue({
        dataInicio,
        dataFim
      });
    }
  }

  private getServidor(dadosServidor): Observable<any> {
    return this.servidorService.getServidor(dadosServidor);
  }

  private getRelatorioAnalitico(params: RelatorioParams) {

    this.relatorioService.getRealtorioAnalitico(params)
      .subscribe(
        (response) => {
          this.dataSource = new MatTableDataSource(response.content);
          this.totalElements = response.totalElements;
          this.mostraResultado = true;
          if(this.totalElements > 0){
            this.showDownloadButton = false
          } else {
            this.showDownloadButton = true
          }
        }
      );
  }

  async getImprimirRelatorioAnalitico(params) {
    this.toastrService.info('Baixando arquivo. Por favor, aguarde!');
    const response = await this.relatorioService.getRealtorioAnalitico(params).toPromise();

    this.relatorioAnalitico = response;

    this.showDownloadButton = true; // Habilita o botão de download
  }

  private criarParametros(pagina: number, itens: number): any {
    const dataInicioFormatada = moment(this.form.value.dataInicio).format('YYYY-MM-DD');
    const dataFimFormatada = moment(this.form.value.dataFim).format('YYYY-MM-DD');

    const parametros = {
      dataInicio: dataInicioFormatada,
      dataFim: dataFimFormatada,
      matricula: this.form.value.matricula ? this.matricula : 0,
      status: this.form.value.statusRegistro,
      pagina: pagina,
      itens: itens,
      ano: this.form.value.ano
    };

    return parametros;
  }

  public onOptionSelected(option: any): void {
    this.matricula = option.matricula;
  }

  public buscarServidor(): void {
    const value = this.form.value.matricula;
    const começaComNúmero = /^\d/.test(value);

    if (value) {
      this.servidorDigitado = value;
      this.getServidor(this.servidorDigitado).subscribe(
        (response) => {
          this.options = response.content;

          if (começaComNúmero == false) {
            this.filteredOptions = this.options.filter((option) =>
              option.nome.toLowerCase().includes(value.toLowerCase())
            );
          } else {
            this.filteredOptions = this.options.filter((option) =>
              option.matricula);
          }
          this.autoTrigger.openPanel();
        },
        (error) => {
          console.error(error);
        }
      );

    } else {
      this.options = [];
      this.filteredOptions = [];
    }
  }

  public buscarRelatorio(pageIndex: number = 0) {

    if (this.form.valid) {
      const parametros = this.criarParametros(pageIndex, this.pageSize);
      this.totalElements = 0;
      this.getRelatorioAnalitico(parametros)
    } else {
      this.toastrService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
    }
  }

  async downloadExcel() {

    const parametros = this.criarParametros(0, this.totalElements);
    await this.getImprimirRelatorioAnalitico(parametros); // Aguarda a conclusão da solicitação
    if (!this.relatorioAnalitico || this.relatorioAnalitico.length === 0) {
      return; // Não gera o relatório se não houver dados
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('RelatorioAnalitica');


    const titleFont = {
      name: 'Arial',
      size: 11,
      bold: true,
      color: { argb: 'FFFFFF' }
    };

    const contentFont = {
      name: 'Arial',
      size: 9,

    };

    // Adicione os títulos da coluna
    const headerRow = worksheet.addRow(['Matrícula', 'Nome', 'Lotação', 'Data Início', 'Data Finalização', 'Status']);
    headerRow.eachCell(cell => {
      cell.font = titleFont;
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '2187E5' }
      };
    });
    this.relatorioAnalitico.content.forEach(item => {
      const row = worksheet.addRow([item.matricula, item.nome, item.lotacao, item.dataCadastro, item.dataFinalizacao, item.status]);
      row.eachCell(cell => {
        cell.font = contentFont;

      });
    });

    // Ajuste a largura das colunas com base no tamanho do conteúdo
    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        const columnLength = cell.value ? String(cell.value).length : 10; // 10 é um valor mínimo arbitrário
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength + 2; // Adicione um espaço extra para melhor legibilidade
    });

    // Crie um Blob do arquivo Excel
    const blob = await workbook.xlsx.writeBuffer();

    // Inicie o download do arquivo
    const filename = 'relatorio.xlsx';
    fs.saveAs(new Blob([blob]), filename);
    this.toastrService.success('Arquivo baixado!');
  }

  nextPage(event: PageEvent) {
    this.pageSize = event.pageSize;
    const parametros = this.criarParametros(event.pageIndex, this.pageSize);
    this.getRelatorioAnalitico(parametros);
  }

}
